import React, { useRef, useState, useEffect } from "react";
import iris from "../../img/oeil/iris.png";
import oeil from "../../img/oeil/oeil.gif";
import "./Oeil.css";

const MAX_RADIUS = 10;
const EASING = 0.18;

const Oeil: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const targetPos = useRef({ x: 50, y: 50 });
  const [irisPos, setIrisPos] = useState({ x: 50, y: 50 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const angle = Math.atan2(dy, dx);
      const offset = Math.min(
        MAX_RADIUS * (dist / window.innerWidth),
        MAX_RADIUS * (dist / window.innerHeight)
      );
      const irisX = rect.width / 2 + Math.cos(angle) * offset;
      const irisY = rect.height / 2 + Math.sin(angle) * offset;
      targetPos.current = {
        x: (irisX / rect.width) * 100,
        y: (irisY / rect.height) * 100,
      };
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    let frameId: number;
    const animate = () => {
      setIrisPos((cur) => ({
        x: cur.x + (targetPos.current.x - cur.x) * EASING,
        y: cur.y + (targetPos.current.y - cur.y) * EASING,
      }));
      frameId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <div className="oeil-container" ref={containerRef}>
      <img src={iris} alt="iris" className="iris-image" style={{ left: `${irisPos.x}%`, top: `${irisPos.y}%` }} />
      <img src={oeil} alt="" className="oeil-image" />
    </div>
  );
};

export default Oeil;
